import { render, staticRenderFns } from "./AddTicket.vue?vue&type=template&id=32fa9a72&scoped=true"
import script from "./AddTicket.vue?vue&type=script&lang=js"
export * from "./AddTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fa9a72",
  null
  
)

export default component.exports